<template>
    <div :class="{'i18n_container': true, 'i18n_container_changed': changed}">
        <a-form :model="formRecord">
           <a-form-item v-if="value == ''" label="KEY">
            <span>KEY 不存在，系统异常</span>
          </a-form-item>
          <a-form-item :label="showTitle ? '中文' : ''" name="lang_zh">
            <a-input @change="handleChange"  v-model:value="formRecord.lang_zh" placeholder="请输入中文" />
          </a-form-item>
          <a-form-item :label="showTitle ? '英文' : ''" name="lang_en">
            <a-input @change="handleChange"   v-model:value="formRecord.lang_en" placeholder="Please input English" />
          </a-form-item>
          <!-- <a-form-item label="日文">
            <a-input  v-model:value="formRecord.lang_jp" />
          </a-form-item>
          <a-form-item label="韩文">
            <a-input  v-model:value="formRecord.lang_kr" />
          </a-form-item>
          <a-form-item label="泰文">
            <a-input  v-model:value="formRecord.lang_th" />
          </a-form-item> -->
          <div style="display: flex; flex-direction: row; justify-content: space-between;">
            <span v-show="loading">Loading ...</span>
            <a-alert v-if="changed" type="error" message="未保存" banner />
            <a-tooltip :title="value">
              <a-button v-if="changed" :loading="loading" @click="handleConfirm" type="primary" >保存</a-button>
              <a-alert  v-else  type="success" message="已保存" banner />
            </a-tooltip>
            
            <!-- <a-button v-else @click="handleConfirm" type="primary"    >保存文案</a-button> -->

          </div>
          
        </a-form>
        
      
    </div>
   
  </template>
  <script>
  
  import { defineComponent, reactive, ref } from 'vue'
  import request from '@/utils/request'
  import { Modal, message } from 'ant-design-vue';
  import OSS from 'ali-oss'

  const FormRecord = {
    id: 0,
    uniq_key: '',
    lang_zh: '',
    lang_en: '',
    lang_jp: '',
    lang_kr: '',
    lang_th: '',
  }
  let inputDebounceTimer = null
  export default defineComponent({
    emits: ['ok', 'update:valid', 'update:zh', 'change'],
    props: ['value',  'valid', 'showTitle'],
    components:{
      
    },
    watch: {
      value: {
        handler(newVal, oldVal) {
          if (newVal != oldVal) {
            this.GetByKey()
          }
        },
        immediate: true,
      },
    },
    data(){
      return {
        loading: false,
        openDia: false,
        changed: true,
        formRecord: {
          ...FormRecord,
        },
      }
    },
    mounted() {
      this.GetByKey()
    },
    methods: {
      genkey(){
        return this.value
      },
      async GetByKey(){
        this.loading = true
        try {
          const rsp = await request.get(`/api/i18n/texts/key`, {
            key: this.genkey(),
          })
          if (rsp.data.result) {
            this.formRecord = rsp.data.result
            this.$emit('update:valid', true)
            this.$emit('update:zh', this.formRecord.lang_zh)
            this.changed = false
          } else {
            this.formRecord = {
              ...FormRecord,
            }
            this.$emit('update:valid', false)
            this.changed = true
          }
        } catch (error) {
          message.error(error.message)
        }
        this.loading = false
         
      },
      async handleConfirm(evt){
        if (this.formRecord.lang_zh == '') {
          message.error('请输入中文文案')
          return
        }
        if (this.formRecord.lang_en == '') {
          message.error('请输入英文文案')
          return
        }
        this.loading = true
        try {
          if (this.formRecord.id) {
            const rsp = await request.put(`/api/i18n/texts/${this.formRecord.id}`, {
              ...this.formRecord,
              uniq_key: this.genkey(),
            })
          } else {
            const rsp = await request.post('/api/i18n/texts', {
              ...this.formRecord,
              uniq_key: this.genkey(),
            })
            this.formRecord.id = rsp.data.id
          }
          this.changed = false
          this.$emit('update:valid', true)
          this.$emit('update:zh', this.formRecord.lang_zh)
        } catch (error) {
          message.error(error.message)
        }
        this.loading = false
      },
      handleChange(evt){
        this.changed = true
        this.$emit('change', this.formRecord)
        this.$emit('update:valid', false)
      }
    },
  })
  </script>
  <style  scoped>
  .green-btn:hover{
    color: #EEE;
    border:1px solid #EEE;
  }
  .i18n_container_changed {
    background: #fff2f0 !important;
  }
  .i18n_container {
    background: #f6ffed;
    border-radius: 8px;
    padding: 8px;
  }
  </style>